import React, { useMemo } from "react";
import "./SingleProgram.css";

const Documents = ({ programDocuments }) => {
  // Group documents by type
  const groupedDocuments = useMemo(() => {
    if (!programDocuments) return {};

    return programDocuments.reduce((acc, doc) => {
      const type = doc.type.split("_")[0].toUpperCase();
      if (!acc[type]) {
        acc[type] = [];
      }
      acc[type].push(doc);
      return acc;
    }, {});
  }, [programDocuments]);

  // Format document type for display
  const formatDocumentType = (type) => {
    // Check if the type is "Other Documents" and replace it with "Autre Documents"
    if (type.toUpperCase().includes("OTHER")) {
      return "Autre Documents";
    }
    // Format other types as before
    return type
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  if (!programDocuments || programDocuments.length === 0) {
    return (
      <section id="documents" className="mt-70">
        <p className="semibold fs16 pink mb-10">Documents</p>
        <div className="bg-white radius5 px-20 py-20">
          <div className="text-muted">Pas de documents disponibles</div>
        </div>
      </section>
    );
  }

  return (
    <section id="documents" className="mt-70">
      <p className="semibold fs16 pink mb-10">Documents</p>
      <div className="bg-white radius5 px-20 py-20">
        <div className="accordion" id="accordionDocuments">
          {Object.entries(groupedDocuments).map(([type, docs], index) => (
            <div className="accordion-item" key={type}>
              <h2 className="accordion-header" id={`heading-${type}`}>
                <button
                  className="accordion-button semibold fs21 darkGrey bg-soft-pink"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse-${type}`}
                  aria-expanded={index === 0}
                  aria-controls={`collapse-${type}`}
                >
                  {type == "OTHER" ? "Autre Documents" : type}
                </button>
              </h2>
              <div
                id={`collapse-${type}`}
                className={`accordion-collapse collapse ${
                  index === 0 ? "show" : ""
                }`}
                aria-labelledby={`heading-${type}`}
              >
                <div className="accordion-body">
                  {docs.map((pdf) => (
                    <div key={pdf.documentId} className="mb-10">
                      <a
                        href={pdf.original_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Télécharger le document"
                        className="d-flex align-items-center text-decoration-none scaleOnHover"
                      >
                        <i className="bi bi-file-earmark-pdf me-2 text-danger"></i>
                        <span className="text-dark">
                          {formatDocumentType(pdf.type)}
                        </span>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Documents;
